<div class="page-container">
  <div class="box">
    <div fxFlex="100">
      <div fxLayout="column" fxFlexAlign="stretch">
        <div fxFlex="100">
          <mat-card appearance="outlined" style="padding: 2em">
            <mat-card-content>
              <h1>Datenschutzerklärung</h1>
              <div [innerHtml]="content | safeHtmlPipe"></div>

              <div style="height: 2em"></div>

              <h3>Zusätzliche Informationen</h3>
              <h4>Application Insights</h4>
              <p>
                In unserer Anwendung wird Application Insights verwendet. Application Insights ist einen
                Webanalysedienst der Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399 USA
                („Microsoft“).
              </p>
              <p>
                Mit diesem werden Informationen zu ihrer Webseitenaktivität gesammelt und zur statistischen
                Auswertung bereitgestellt. Desweiteren werden Fehlermeldungen übertragen, die für die
                Verbesserung der Anwendnung genutzt werden. Ihre IP-Adresse wird nicht gespeichert und die
                Datensätze anonymisiert. Die erzeugten Informationen über Ihre Benutzung dieser Website werden
                in der Regel an einen Server von Microsoft in den USA übertragen und dort gespeichert.
                Microsoft verarbeitet diese Informationen in unserem Auftrag. Die Rechtsgrundlage für die
                Datenverarbeitung ist Art. 6 Abs. 1 lit. f) DSGVO.
              </p>
              <p>
                Mehr Informationen zum Thema Datenschutz und Azure finden Sie unter
                https://privacy.microsoft.com/de-de/privacystatement.
              </p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
